module.exports = __webpack_public_path__ + "static/media/SIH.cdb157eb.png";